import {
    NinchatActionType,
    NinchatDescribeAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatAccessFoundEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeAccessAction}`,
    async (arg: NinchatActionParams<NinchatDescribeAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeAccessAction

        try {
            return await ninchatClient.send(params) as NinchatAccessFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
